import type { DLocalCreateTokenError, DLocalValidationError } from '#src/app/shared/types/payment';

import { useDLocalMapHttpError } from './useDLocalMapHttpError';
import { useDLocalValidationError } from './useDLocalValidationError';

export type UseDLocalMapErrorResult = {
	mapDLocalValidationError: (dlocalError: DLocalCreateTokenError) => {
		field: keyof DLocalValidationError;
		message: string;
	};
	mapDLocalHttpError: (dlocalError: DLocalCreateTokenError) => string;
	translateDLocalFieldError: (field: keyof DLocalValidationError) => string | undefined;
};

export function useDLocalMapError(): UseDLocalMapErrorResult {
	const mapDLocalHttpError = useDLocalMapHttpError();
	const { mapDLocalValidationError, translateDLocalFieldError } = useDLocalValidationError();

	return { mapDLocalValidationError, mapDLocalHttpError, translateDLocalFieldError };
}
